import React, { useState, useEffect, useMemo } from 'react';
/* global axios */
import api from '../services/apiService';
import { Link } from 'react-router-dom';  // Importiere Link für die Navigation
import { Helmet } from 'react-helmet';  // Import von React Helmet
import Select from 'react-select'; // Neu: react-select importieren

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);  // Zustand für die Kundenliste
  const [loading, setLoading] = useState(true);     // Zustand für den Ladeindikator
  const [error, setError] = useState(null);         // Zustand für Fehler

  const DEFAULT_FILTERS = { customerNumber: null, debtorNumber: null, company: null, city: null };

  const [filters, setFilters] = useState(() => {
    const storedFilters = localStorage.getItem('customerListFilters');
    return storedFilters ? JSON.parse(storedFilters) : DEFAULT_FILTERS;
  });

  // ✅ HIER: Reset bei Reload
  useEffect(() => {
    localStorage.removeItem('customerListFilters');
    setFilters(DEFAULT_FILTERS);
    setCurrentPage(1);
  }, []);
  
  useEffect(() => {
    localStorage.setItem('customerListFilters', JSON.stringify(filters));
  }, [filters]);


   // State für serverseitige Filteroptionen (dieser Endpoint liefert z. B. distinct Werte)
   const [serverFilterOptions, setServerFilterOptions] = useState({
    customerNumbers: [],
    debtorNumbers: [],
    companies: [],
    cities: [],
  });

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const response = await api.get('/customers/filter-options');
        setServerFilterOptions(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Filteroptionen:', error);
      }
    };
    fetchFilterOptions();
  }, []);

  // Pagination-Zustände
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 25;

  // Erzeugt einen Query-String aus den Filter- und Pagination-Zuständen
  const buildQuery = () => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('page', currentPage);
    if (filters.customerNumber) {
      params.append('customerNumber', filters.customerNumber.value);
    }
    if (filters.debtorNumber) {
      params.append('debtorNumber', filters.debtorNumber.value);
    }
    if (filters.company) {
      params.append('company', filters.company.value);
    }
    if (filters.city) {
      params.append('city', filters.city.value);
    }
    return params.toString() ? `?${params.toString()}` : '';
  };
  


   // API-Call zum Laden der Kunden mit Filter und Pagination
   useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const validCompany =
  filters.company?.value &&
  serverFilterOptions.companies.includes(filters.company.value)
    ? filters.company.value
    : undefined;

const response = await api.get('/customers/list', {
  params: {
    limit,
    page: currentPage,
    customerNumber: filters.customerNumber?.value || undefined,
    debtorNumber: filters.debtorNumber?.value || undefined,
    company: validCompany,        // <— nur senden, wenn noch gültig
    city: filters.city?.value || undefined,
  },
});
        // Erwartet wird ein Objekt { total, page, pages, data: [...] }
        setCustomers(response.data.data);
        setTotalPages(response.data.pages);
        setLoading(false);
      } catch (error) {
        console.error("Fehler beim Abrufen der Kunden:", error);
        setError("Fehler beim Abrufen der Kunden");
        setLoading(false);
      }
    };

    fetchCustomers();
  }, [filters, currentPage]);



  // Wenn die Seite noch lädt, zeige einen Ladeindikator
  if (loading) {
    return <div>Lade Kunden...</div>;
  }

  // Wenn ein Fehler auftritt, zeige eine Fehlermeldung
  if (error) {
    return <div>{error}</div>;
  }

  // Wenn keine Kunden vorhanden sind
  if (customers.length === 0) {
    return <div>Keine Kunden gefunden.</div>;
  }

  // Anzeige der Kundenliste
  return (
    <div>
      <Helmet>
        <title>Kundenliste</title>
        <meta name="description" content="Kundenliste" />
      </Helmet>
      <h2>Kundenliste</h2>

      {/* Button zum Anlegen eines neuen Kunden */}
      <Link to="/customerform">
        <button type="button" style={{
                          
                          marginBottom: '15px',
                          
                        }}>Neuen Kunden anlegen</button>
      </Link>

      {/* Filterleiste */}
      <div style={{ marginBottom: '20px' }}>
        <h3>Filter</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
          <Select
            options={serverFilterOptions.customerNumbers.map(val => ({ value: val, label: val }))}
            placeholder="Kundennummer"
            isClearable
            value={filters.customerNumber}
            onChange={(selected) => {
   setFilters({ ...filters, customerNumber: selected });
   setCurrentPage(1);
 }}
            
          />
          <Select
            options={serverFilterOptions.debtorNumbers.map(val => ({ value: val, label: val }))}
            placeholder="Debitorennummer"
            isClearable
            value={filters.debtorNumber}
            onChange={(selected) => {
   setFilters({ ...filters, debtorNumber: selected });
   setCurrentPage(1);
 }}
            
          />
          <Select
            options={serverFilterOptions.companies.map(val => ({ value: val, label: val }))}
            placeholder="Kundenname"
            isClearable
            value={filters.company}
            onChange={(selected) => {
   setFilters({ ...filters, company: selected });
   setCurrentPage(1);
 }}
            
          />
          <Select
            options={serverFilterOptions.cities.map(val => ({ value: val, label: val }))}
            placeholder="Ort"
            isClearable
            value={filters.city}
            onChange={(selected) => setFilters({ ...filters, city: selected })}
            
          />
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>Kundennummer</th>
            <th>Debitorennummer</th>
            <th>Kundenname</th>
            <th>PLZ</th>
            <th>Ort</th>
            <th>E-Mail</th>
            <th>Telefon</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
  {customers.map((customer) => (
    <tr
      key={customer.id}
      style={{
        backgroundColor: customer.isBlocked ? 'rgba(255, 0, 0, 0.08)' : undefined,
        borderLeft: customer.isBlocked ? '4px solid rgba(220, 0, 0, 0.8)' : undefined,
      }}
      title={customer.isBlocked
        ? `Gesperrt${customer.blockReason ? `: ${customer.blockReason}` : ''}`
        : undefined}
    >
      <td>{customer.customerNumber}</td>
      <td>{customer.debtorNumber}</td>
      <td>
        {customer.company}
        {customer.isBlocked && (
          <span
            style={{
              marginLeft: 8,
              padding: '2px 6px',
              fontSize: 12,
              borderRadius: 6,
              background: 'rgba(220, 0, 0, 0.12)',
              color: 'rgb(160, 0, 0)',
              fontWeight: 600,
            }}
          >
            GESPERRT
          </span>
        )}
      </td>
      <td>{customer.postalCode}</td>
      <td>{customer.city}</td>
      <td>{customer.email}</td>
      <td>{customer.phone}</td>
      <td>
        <Link to={`/customerform/${customer.id}`}>Bearbeiten</Link>
      </td>
    </tr>
  ))}
</tbody>
      </table>
{/* Pagination */}
<div style={{ marginTop: '1rem' }}>
        <button
          onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
          disabled={currentPage === 1}
          style={{
            fontSize: '15px',
            padding: '8px 12px',
            backgroundColor:'rgb(155, 155, 155)',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }} 
        >
          Vorherige
        </button>
        <span style={{ margin: '0 1rem' }}>
          Seite {currentPage} von {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage >= totalPages}
          style={{
            fontSize: '15px',
            padding: '8px 12px',
            backgroundColor:'rgb(155, 155, 155)',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }} 
        >
          Nächste
        </button>
      </div>

    </div>
  );
};

export default CustomerList;
